module.exports = __webpack_public_path__ + "static/media/ice-cream.c17e76b2.jpg";